import React from 'react';
import Icon from '../app_components/Icon';
import { semantic } from '@lexody/design-tokens';

class LexCheckbox extends React.Component {
  render() {
    const {
      checked,
      onChange,
      label,
      description,
      premium = false,
      name,
      value,
    } = this.props;

    const className = [
      'lex-check',
      checked ? 'lex-check--checked' : '',
      premium ? 'lex-check--premium' : '',
    ].filter(Boolean).join(' ');

    return (
      <label className={className}>
        <input
          type="checkbox"
          className="lex-toggle__input"
          checked={checked}
          name={name}
          value={value}
          onChange={(e) => onChange(e.target.checked)}
        />
        <span className="lex-check__box" aria-hidden="true">
          {checked && (
            <Icon name="check" size={14} color={semantic.greyscale.text.negative} solid />
          )}
        </span>
        <span className="lex-check__label">
          {description ? (
            <>
              <strong>{label}</strong>
              {description}
            </>
          ) : (
            label
          )}
        </span>
      </label>
    );
  }
}

export default LexCheckbox;
